import React, { Component } from 'react';
import DrawDataList from './DrawDataList';

export default class DrawData extends Component{
    constructor(){
        super()
    }

    render(){
        return(
            <div className="row">
                <article className="col-xs-12">
                    <div className="jarviswidget" id="wid-id-0" data-widget-editbutton="false">
                        <header>
                            <span className="widget-icon"> <i className="fa fa-gear"></i> </span>
                            <h2><strong>Draw</strong> <i>Data</i></h2>
                        </header>
                        <div>
                            <div className="jarviswidget-editbox"></div>
                            <div id="drawDataCon" className="widget-body">
                                <DrawDataList />
                            </div>                            
                        </div>
                    </div>
                </article>
            </div>
        )
    }
}